import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { CallSocketService } from '../../Service/call-socket.service';
import { CommonStandaloneImports } from '../common/common-standalone-imports';
import { ApiService } from '../../Service/api.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotificationCountService } from '../../Service/notification-count.service';

@Component({
  standalone: true,
  selector: 'app-amb-notification',
  imports: [...CommonStandaloneImports],
  templateUrl: './amb-notification.component.html',
  styleUrls: ['./amb-notification.component.scss'],
})
export class AmbNotificationComponent implements OnInit {
  @Input() showNotification: boolean = false;
  @Input() notifications: any = [];
  showAllPopup = false;
  today = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Africa/Harare' }),
  );
  isNotificationOpen = false;
  selectedNotification: any = null;
  notificationDetails: any;

  constructor(
    private cdRef: ChangeDetectorRef,
    private socketService: CallSocketService,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private notificationCountService: NotificationCountService,
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (!changes?.showNotification?.currentValue) {
      this.closeNotificationPopup();
    }
  }

  getNotificationIcon(typeId: any): any {
    switch (typeId) {
      case 4:
        return 'assets/notification-icons/new_ambulance.webp'; // New Ambulance Request
      case 5:
      case 17:
        return 'assets/notification-icons/request_accepted.webp'; // Request Accepted // Booking Confirmed
      case 6:
        return 'assets/notification-icons/request_rejected.webp'; // Request Rejected
      case 7:
        return 'assets/notification-icons/trip_started.webp'; // Trip Started
      case 8:
        return 'assets/notification-icons/trip_completed.webp'; // Trip Completed
      case 9:
        return 'assets/notification-icons/ambulance_enroute.webp'; // Payment Request
      case 10:
        return 'assets/notification-icons/new_consultation.webp'; // New Consultation Booked
      case 11:
        return 'assets/notification-icons/trip_started.webp'; // Upcoming Consultation
      case 12:
        return 'assets/notification-icons/consultation_cancelled.webp'; // Consultation Cancelled
      case 13:
        return 'assets/notification-icons/pending.webp'; // Consultation Pending
      case 14:
        return 'assets/notification-icons/new_note.webp'; // New note received
      case 15:
        return 'assets/notification-icons/request_accepted.webp'; // Ambulance Accepted
      case 16:
        return 'assets/notification-icons/ambulance_enroute.webp'; // Ambulance En Route
      case 18:
        return 'assets/notification-icons/consultation_cancelled.webp'; // Booking Cancelled
      case 19:
        return 'assets/notification-icons/plan_renewal_reminder.webp'; // Plan Renewal Reminder
      case 20:
        return 'assets/notification-icons/ambulance_enroute.webp'; // Payment Required
      case 21:
        return 'assets/notification-icons/pending.webp'; // Payment Required
    }
  }

  private getUserNotifications() {
    const userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = userProfile.user_id;

    this.apiService.getRecentNotifications(userId).subscribe({
      next: (apiRes: any) => {
        const unreadNotifications = (apiRes?.data || []).filter(
          (notif: any) => notif.is_read === 1,
        );

        const notifCount = unreadNotifications.length;
        this.notificationCountService.setCount(notifCount);

        this.notifications = apiRes?.data?.map((el: any) => {
          return {
            ...el,
            message: el?.message ? this.getSafeMessage(el?.message) : '',
          };
        });
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Failed to fetch Notification data', error);
      },
    });
  }

  getSafeMessage(message: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(message);
  }

  openNotificationPopup(notification: any, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }

    this.selectedNotification = notification;
    this.isNotificationOpen = true;
    this.showNotification = true;

    this.apiService.getNotificationByBookingId(notification?.id).subscribe({
      next: (apiRes: any) => {
        if (apiRes.data.success) {
          this.notificationDetails = apiRes.data;
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Failed to fetch Notification data', error);
      },
    });

    if (notification.is_read == 0) {
      return;
    }

    const payload = {
      id: notification?.id,
      type: 'UNREAD',
      is_read: 1,
    };

    this.apiService.updateNotification(payload).subscribe({
      next: (apiRes: any) => {
        this.getUserNotifications();
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Failed to fetch Notification data', error);
      },
    });
  }

  closeNotificationPopup() {
    this.isNotificationOpen = false;
    this.selectedNotification = null;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.socketService.disconnectSession();
  }

  ngOnDestroy() {
    this.socketService.disconnectSession();
  }
}
